export default __webpack_public_path__ + "static/media/GNS.0840a95c.svg";